import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import Fab from "@mui/material/Fab";
import Tooltip from "@mui/material/Tooltip";
import withTranslationWrapper from "../../HOC/withTranslation";
import ChatPanel from "./ChatPanel";
import "./index.scss";

const FleetBot = ({
  themecolors,
  logInUser,
  translate,
  vehicles,
  devices3,
  positions,
  deviceRelatedData,
  allNotifications,
  ServerSetting,
}) => {
  const [open, setOpen] = useState(false);

  const close = useCallback(() => setOpen(false), []);
  const toggle = useCallback(() => setOpen((value) => !value), []);

  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        close();
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, close]);

  const currency =
    logInUser?.attributes?.currencyLabel || translate("fleetBotCurrency");

  const liveContext = {
    vehicles,
    devices3,
    positions,
    deviceRelatedData,
    allNotifications,
    logInUser,
    ServerSetting,
  };

  return (
    <div
      className="fleetbot-root"
      style={{
        "--fb-accent": themecolors.themeLightColor,
        "--fb-accent-text": themecolors.themeLightInverse,
        "--fb-dark": themecolors.themeDarkColor,
        "--fb-dark-text": themecolors.themeInverse,
        "--fb-text": themecolors.textColor,
        "--fb-bg": themecolors.backgroundColor || "#ffffff",
        "--fb-success": themecolors.success || "#4BB543",
        "--fb-error": themecolors.error || "#ff424c",
        "--fb-green": themecolors.menuActiveBackground || "#6FBD43",
      }}
    >
      <ChatPanel
        open={open}
        onClose={close}
        themecolors={themecolors}
        translate={translate}
        currency={currency}
        liveContext={liveContext}
      />

      <Tooltip
        title={open ? translate("sharedCancel") : translate("askFleetBot")}
        placement="left"
        arrow
      >
        <Fab
          className={`fleetbot-fab ${open ? "is-open" : ""}`}
          onClick={toggle}
          aria-expanded={open}
          aria-label={translate("askFleetBot")}
          sx={{
            position: "fixed",
            right: 20,
            bottom: 36,
            zIndex: 9995,
            bgcolor: themecolors.themeLightColor,
            color: themecolors.themeLightInverse,
            boxShadow: "0 8px 20px rgba(30, 114, 184, 0.35)",
            "&:hover": {
              bgcolor: themecolors.themeLightColor,
              filter: "brightness(1.06)",
            },
          }}
        >
          <span className="fleetbot-fab-ring" aria-hidden="true" />
          {open ? <CloseIcon /> : <SmartToyOutlinedIcon />}
        </Fab>
      </Tooltip>
    </div>
  );
};

const mapStateToProps = (state) => ({
  themecolors: state.themeColors,
  logInUser: state.logInUsers,
  vehicles: state.vehicles,
  devices3: state.devices3,
  positions: state.positions,
  deviceRelatedData: state.deviceRelatedData,
  allNotifications: state.allNotifications,
  ServerSetting: state.ServerSetting,
});

export default connect(mapStateToProps)(withTranslationWrapper(FleetBot));
